import { Vector2 } from "../libs/math";


// i set it in the css
const Canvas_Size : Vector2 = new Vector2(1100,800);


export {Canvas_Size};